const css = `.rbQZ_a__container{white-space:pre-line;position:relative}.rbQZ_a__ruler{visibility:hidden}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"container":"rbQZ_a__container","ruler":"rbQZ_a__ruler"};
